module.exports = __webpack_public_path__ + "static/media/Cambam-bali-min.d5c2cf97.png";